import { createSelector } from "reselect";
import { getSelectedCategoryType } from "./basicDetails";
import { AHOC_REQUIRED_DOCUMENTS } from "../../actions/allsureHomeClaim/types";
import { getAllsureHomeClaim } from "./index";

 const getAllReferenceDataState=createSelector( getAllsureHomeClaim,
  (allsureHomeClaim) => allsureHomeClaim.referenceData)

export const getAhocApiStatus=createSelector( getAllReferenceDataState,
  (referenceData) => referenceData.apiStatus)

export const getAhocReferenceNumber=createSelector( getAllReferenceDataState,
  (referenceData) => referenceData.referenceNumber)

export const getAhocReferenceData = createSelector(
    () => ({
        alternatePersonOptionsReferenceData:[
            {
                label: "Friends",
                value: "Friends"
              },
            {
                label: "Family",
                value: "Family"
              },
            {
                label: "None",
                value: "None"
              },
        ],
        categoryTypeReferenceData:[
            {
              label: "Accidental damage - Accidental Bursting",
              value: "Accidental damage - Accidental Bursting"
            },
            {
              label: "Accidental damage Business Goods And Equipment",
              value: "Accidental damage Business Goods And Equipment"
            },
            {
              label: "Accidental damage Clearance Costs",
              value: "Accidental damage Clearance Costs"
            },
            {
              label: "Accidental damage - Damage To Garden",
              value: "Accidental damage - Damage To Garden"
            },
            {
              label: "Accidental damage - Documents",
              value: "Accidental damage - Documents"
            },
            {
              label: "Accidental damage - Domestic Staff Property",
              value: "Accidental damage - Domestic Staff Property"
            },
            {
              label: "Accidental damage - Guests Property",
              value: "Accidental damage - Guests Property"
            },
            {
              label: "Accidental damage - Impact",
              value: "Accidental damage - Impact"
            },
            {
              label: "Accidental damage - Malicious Damage",
              value: "Accidental damage - Malicious Damage"
            },
            {
              label: "Accidental damage - Money And Negotiable Instrument",
              value: "Accidental damage - Money And Negotiable Instrument"
            },
            {
              label: "Accidental damage - Non Standard building",
              value: "Accidental damage - Non Standard building"
            },
            {
              label: "Accidental damage - Rent",
              value: "Accidental damage - Rent"
            },
            {
              label: "Accidental damage - Security Guard",
              value: "Accidental damage - Security Guard"
            },
            {
              label: "Accidental damage - Water damage (not Weather relay)",
              value: "Accidental damage - Water damage (not Weather relay)"
            },
            {
              label: "Accidental death - Personal Accident Death",
              value: "Accidental death - Personal Accident Death"
            },
            {
              label: "Accidental damage to audiovisual equipment & glass - Accidental Loss Or Damage",
              value: "Accidental damage to audiovisual equipment & glass - Accidental Loss Or Damage"
            },
            {
              label: "Domestic telephone instruments - Accidental Loss Or Damage",
              value: "Domestic telephone instruments - Accidental Loss Or Damage"
            },
            {
              label: "Earthquake - Business Goods And Equipment",
              value: "Earthquake - Business Goods And Equipment"
            },
            {
              label: "Earthquake - Clearance Costs",
              value: "Earthquake - Clearance Costs"
            },
            {
              label: "Fire/Lightning/Explosion - Lightning",
              value: "Fire/Lightning/Explosion - Lightning"
            },
            {
              label: "Fire/Lightning/Explosion - Money And Negotiable Instrument",
              value: "Fire/Lightning/Explosion - Money And Negotiable Instrument"
            },
            {
              label: "Fire/Lightning/Explosion - Non Standard building",
              value: "Fire/Lightning/Explosion - Non Standard building"
            },
            {
              label: "Fire/Lightning/Explosion = Rent",
              value: "Fire/Lightning/Explosion = Rent"
            },
            {
              label: "Fire/Lightning/Explosion - Security Guard",
              value: "Fire/Lightning/Explosion - Security Guard"
            },
            {
              label: "Keys and locks - Loss Of Keys And/Or Locks",
              value: "Keys and locks - Loss Of Keys And/Or Locks"
            },
            {
              label: "Liability Occupiers/Personal Liability",
              value: "Liability Occupiers/Personal Liability"
            },
            {
              label: "Liability - Personal Liability General",
              value: "Liability - Personal Liability General"
            },
            {
              label: "Loss of water by leakage - Loss Of Water By Leakage",
              value: "Loss of water by leakage - Loss Of Water By Leakage"
            },
            {
              label: "Medical expenses - Accidental Bodily Injury",
              value: "Medical expenses - Accidental Bodily Injury"
            },
            {
              label: "Refrigerator and deep freeze contents - Deterioration Of Food",
              value: "Refrigerator and deep freeze contents - Deterioration Of Food"
            },
            {
              label: "Storm/Wind/Hail/Snow/Water - Business Goods And Equipment",
              value: "Storm/Wind/Hail/Snow/Water - Business Goods And Equipment"
            },
            {
              label: "Storm/Wind/Hail/Snow/Water - Clearance Costs",
              value: "Storm/Wind/Hail/Snow/Water - Clearance Costs"
            },
            {
              label: "Storm/Wind/Hail/Snow/Water - Documents",
              value: "Storm/Wind/Hail/Snow/Water - Documents"
            },
            {
              label: "Storm/Wind/Hail/Snow/Water - Domestic Staff Property",
              value: "Storm/Wind/Hail/Snow/Water - Domestic Staff Property"
            },
            {
              label: "Storm/Wind/Hail/Snow/Water - Flood",
              value: "Storm/Wind/Hail/Snow/Water - Flood"
            },
            {
              label: "Storm/Wind/Hail/Snow/Water - Guests Property",
              value: "Storm/Wind/Hail/Snow/Water - Guests Property"
            },
            {
              label: "Storm/Wind/Hail/Snow/Water - Hail",
              value: "Storm/Wind/Hail/Snow/Water - Hail"
            },
            {
              label: "Storm/Wind/Hail/Snow/Water - Money And Negotiable Instrument",
              value: "Storm/Wind/Hail/Snow/Water - Money And Negotiable Instrument"
            },
            {
              label: "Storm/Wind/Hail/Snow/Water - Non Standard building",
              value: "Storm/Wind/Hail/Snow/Water - Non Standard building"
            },
            {
              label: "Storm/Wind/Hail/Snow/Water - Rent",
              value: "Storm/Wind/Hail/Snow/Water - Rent"
            },
            {
              label: "Storm/Wind/Hail/Snow/Water - Security Guard",
              value: "Storm/Wind/Hail/Snow/Water - Security Guard"
            },
            {
              label: "Storm/Wind/Hail/Snow/Water - Snow",
              value: "Storm/Wind/Hail/Snow/Water - Snow"
            },
            {
              label: "Storm/Wind/Hail/Snow/Water - Storm",
              value: "Storm/Wind/Hail/Snow/Water - Storm"
            },
            {
              label: "Storm/Wind/Hail/Snow/Water - Weather Related Excl Hail",
              value: "Storm/Wind/Hail/Snow/Water - Weather Related Excl Hail"
            },
            {
              label: "Subsidence - Non Standard building",
              value: "Subsidence - Non Standard building"
            },
            {
              label: "Subsidence - Subsidence and landslide",
              value: "Subsidence - Subsidence and landslide"
            },
            {
              label: "Theft - Business Goods And Equipment",
              value: "Theft - Business Goods And Equipment"
            },
            {
              label: "Theft - Documents",
              value: "Theft - Documents"
            },
            {
              label: "Theft - Domestic Staff Property",
              value: "Theft - Domestic Staff Property"
            },
            {
              label: "Theft - Guests Property",
              value: "Theft - Guests Property"
            },
            {
              label: "Theft Hold Up",
              value: "Theft Hold Up"
            },
            {
              label: "Theft - Money And Negotiable Instrument",
              value: "Theft - Money And Negotiable Instrument"
            },
            {
              label: "Theft - Non Standard building",
              value: "Theft - Non Standard building"
            },
            {
              label: "Theft - Rent",
              value: "Theft - Rent"
            },
            {
              label: "Theft - Security Guard",
              value: "Theft - Security Guard"
            },
            {
              label: "Theft - Theft",
              value: "Theft - Theft"
            },
            {
              label: "Theft - Theft Forcible Entry",
              value: "Theft - Theft Forcible Entry"
            },
            {
              label: "Theft - Theft From Grounds",
              value: "Theft - Theft From Grounds"
            },
            {
              label: "Theft - Theft From Outbuildings",
              value: "Theft - Theft From Outbuildings"
            },
            {
              label: "Theft - Theft Non Forcible Entry",
              value: "Theft - Theft Non Forcible Entry"
            },
            {
              label: "Theft - Theft Of Laundry",
              value: "Theft - Theft Of Laundry"
            },
            {
              label: "Transit risk - Transit Away",
              value: "Transit risk - Transit Away"
            },
            {
              label: "Trauma - Personal Accident Trauma",
              value: "Trauma - Personal Accident Trauma"
            },
            {
              label: "Veterinary expenses - Accidental Bodily Injury",
              value: "Veterinary expenses - Accidental Bodily Injury"
            },
            {
              label: "Wild Baboons/Monkeys - Damage by Wild Baboons/Monkeys",
              value: "Wild Baboons/Monkeys - Damage by Wild Baboons/Monkeys"
            }
          ]          
    })
);






